<app-beta-banner [(visible)]="displayBetaBanner" role="banner"></app-beta-banner>
<app-nav-bar data-cy="nav-bar" role="navigation"></app-nav-bar>
<div class="home-container" role="main">
  <div class="message-container">
    <p-messages key="homeMessages" data-cy="home-messages-container"></p-messages>
  </div>
  <app-spinner *ngIf="(patientStateIsLoading$ | async) && (patientStateErrors$ | async) === null"></app-spinner>
  <div *ngIf="!displayAcceptTermsModal && !displayHipaaVerifyModal">
    <div *ngIf="patientStateErrors$ | async">
      <app-page-error [error]="patientStateErrors$ | async"></app-page-error>
    </div>
    <router-outlet
      *ngIf="
        (patientStateIsLoading$ | async) === false &&
        (patientStateErrors$ | async) === null &&
        (selectedPatientId$ | async) !== null
      "
    ></router-outlet>
  </div>
</div>
<app-footer role="contentinfo"></app-footer>

<app-confirmation-modal
  [(visible)]="displaySessionExpirationModal"
  title="Your session is about to expire"
  [message]="
    'Due to inactivity, your session will expire in ' +
    sessionExpirationTimeLeft +
    '. Would you like to continue your session?'
  "
  submitLabel="Yes, Continue session"
  cancelLabel="No, Sign me out"
  (confirmAction)="continueSession()"
  (cancelAction)="terminateSession()"
  data-cy="session-expiration-modal"
>
</app-confirmation-modal>

<app-form-modal
  class="select-none"
  title="Select a Patient Account"
  [(visible)]="displaySelectPatientModal"
  formId="selectPatientForm"
  submitLabel="Select"
  [disabled]="!selectPatientForm.get('selectedPatientId')?.value"
  [noCancel]="true"
  data-cy="select-patient-modal"
>
  <div class="mt-3">
    <form
      [formGroup]="selectPatientForm"
      (ngSubmit)="onSubmitSelectPatient()"
      id="selectPatientForm"
      data-cy="select-patient-form"
    >
      <div *ngFor="let patient of (patientsState$ | async)?.data">
        <app-radio-button-card
          [control]="asFormControl(selectPatientForm.get('selectedPatientId'))"
          name="selectPatientId"
          [value]="patient.id"
          [ariaLabel]="patient.fullName"
          [isSelected]="patient.id === selectPatientForm.get('selectedPatientId')?.value"
          [handleSelect]="changeSelectedPatient.bind(this, patient.id)"
          [centerVertically]="true"
        >
          <div class="flex w-full align-items-center">
            <p-avatar
              class="mr-2"
              [label]="patient.initials || ''"
              styleClass="user-menu-avatar"
              shape="circle"
              data-cy="select-patient-avatar"
            ></p-avatar>
            <div class="flex flex-column">
              <div class="my-0 p2 font-semibold" data-cy="patient-name">
                {{ patient.fullName | titlecase }}
              </div>
              <div class="my-0 p2 font-light text-grey-500" data-cy="patient-id">Patient ID: {{ patient.id }}</div>
            </div>
          </div>
        </app-radio-button-card>
      </div>
    </form>
  </div>
</app-form-modal>

<app-form-modal
  title="Terms & Conditions"
  [(visible)]="displayAcceptTermsModal"
  formId="termsAndConditionsForm"
  [submitLabel]="(updatePatientState$ | async)?.isUpdating ? 'Updating Your Settings...' : 'Continue'"
  [disabled]="(updatePatientState$ | async)?.isUpdating"
  [noCancel]="true"
>
  <div *ngIf="showTermsAndConditionsError">
    <app-message severity="error" data-cy="terms-and-conditions-error-message">
      {{ (updatePatientState$ | async)?.error?.uiMessage }}
    </app-message>
  </div>
  <div class="mt-3">
    <form
      [formGroup]="termsAndConditionsForm"
      (ngSubmit)="onSubmitTermsAndConditions()"
      id="termsAndConditionsForm"
      data-cy="terms-and-conditions-form"
    >
      <app-form-field
        [control]="asFormControl(termsAndConditionsForm.get('acceptedTermsAndConditions'))"
        name="acceptedTermsAndConditions"
        errorLabel="Confirmation"
        [noMargin]="true"
        type="checkbox-binary"
        ><span class="p3"
          >I agree to
          <a [href]="termsAndConditionsUrl" target="_blank">Terms and Conditions</a>
          and
          <a [href]="privacyUrl" target="_blank">Privacy Practices</a>.
        </span>
      </app-form-field>
    </form>
  </div>
</app-form-modal>

<app-hipaa-form
  [displayHipaaVerifyModal]="displayHipaaVerifyModal"
  [afterVerify]="hideHipaaVerifyModal.bind(this)"
></app-hipaa-form>

<app-address-orders-form
  [(visible)]="displayAddressOrdersModal"
  (submitForm)="onAddressOrdersUpdated()"
  [excludeOrderId]="excludeAddressChangeReorderId"
></app-address-orders-form>

<p-toast key="homeToast" position="top-right" data-cy="bottom-center-toast"></p-toast>

<div *ngIf="isAgentUser$ | async">
  <app-agent-bar></app-agent-bar>
</div>
